import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../button/button/index.esm.js';
import { EGDSPrimaryButton } from '../../button/primary-button/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSTertiaryButton } from '../../button/tertiary-button/index.esm.js';
import '../../button/paging-button/index.esm.js';
import styles from '../../styles/uitk-egds-dialog.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSDialogFooter extends React.Component {
  static displayName = 'EGDSDialogFooter';
  static defaultProps = {
    stacked: false
  };
  static footerButtonWrapperClassNames = 'uitk-dialog-footer-button';
  validDialogFooterButtonTypes = element => !!element.type.displayName?.match(/(EGDS|Uitk)(Primary|Tertiary)Button/);
  applyFooterButtonClasses(element) {
    return React.cloneElement(element, {
      ...element.props,
      className: getClassNameList(element.props.className, EGDSDialogFooter.footerButtonWrapperClassNames)
    });
  }
  render() {
    const {
      buttonOne,
      buttonTwo,
      buttonThree,
      stacked,
      disabled,
      children
    } = this.props;
    const Tag1 = buttonOne && buttonOne.type === 'primary' ? EGDSPrimaryButton : EGDSTertiaryButton;
    const Tag2 = buttonTwo && buttonTwo.type === 'primary' ? EGDSPrimaryButton : EGDSTertiaryButton;
    const Tag3 = buttonThree && buttonThree.type === 'primary' ? EGDSPrimaryButton : EGDSTertiaryButton;
    const footerWrapperClassName = getClassNameList('uitk-dialog-footer', {
      'uitk-dialog-footer-stacked': stacked
    }, {
      'is-disabled': disabled
    });
    const footerSectionWrapperClassNames = getClassNameList('uitk-dialog-footer-section');
    const childrenToRender = children && React.Children.toArray(children).filter(this.validDialogFooterButtonTypes).slice(0, stacked ? 3 : 2).map(this.applyFooterButtonClasses);
    if (childrenToRender) {
      return jsx("div", {
        className: footerWrapperClassName,
        children: childrenToRender.map((child, index) => jsx("div", {
          className: footerSectionWrapperClassNames,
          children: child
        }, `footer-button-${index}`))
      });
    }
    return jsxs("div", {
      className: footerWrapperClassName,
      children: [buttonOne && jsx("div", {
        className: footerSectionWrapperClassNames,
        children: jsx(Tag1, {
          disabled: buttonOne.disabled || disabled,
          onClick: disabled ? undefined : buttonOne.onClick,
          href: buttonOne.href,
          className: getClassNameList(EGDSDialogFooter.footerButtonWrapperClassNames),
          "data-stid": buttonOne.stid,
          "aria-label": buttonOne.accessibilityLabel,
          children: buttonOne.text
        })
      }), buttonTwo && jsx("div", {
        className: footerSectionWrapperClassNames,
        children: jsx(Tag2, {
          disabled: buttonTwo.disabled || disabled,
          onClick: disabled ? undefined : buttonTwo.onClick,
          href: buttonTwo.href,
          className: getClassNameList(EGDSDialogFooter.footerButtonWrapperClassNames),
          "data-stid": buttonTwo.stid,
          "aria-label": buttonTwo.accessibilityLabel,
          children: buttonTwo.text
        })
      }), stacked && buttonThree && jsx("div", {
        className: footerSectionWrapperClassNames,
        children: jsx(Tag3, {
          disabled: buttonThree.disabled || disabled,
          onClick: disabled ? undefined : buttonThree.onClick,
          href: buttonThree.href,
          className: getClassNameList(EGDSDialogFooter.footerButtonWrapperClassNames),
          "data-stid": buttonThree.stid,
          "aria-label": buttonThree.accessibilityLabel,
          children: buttonThree.text
        })
      })]
    });
  }
}
export { EGDSDialogFooter };